import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import { useLocation, useNavigate } from "react-router-dom";
import Star from "@mui/icons-material/Star";
import { SideMenuOption } from "../core/SideMenuOption";
import { Path } from "../Path";
import { useMyProfile } from "@seabrookstudios/pitch2table";
import CircularProgress from "@mui/material/CircularProgress";
import Alert from "@mui/material/Alert";
import Card from "@mui/material/Card";
import { CenterOnPage } from "../core/CenterOnPage";
import { Features } from "../games/features";

export const PremiumButton = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const onClickHandler = () => {
    navigate(Path.Premium);
  };

  return (
    <SideMenuOption
      label="Premium"
      tooltip="Upgrade your subscription"
      onClick={onClickHandler}
      selected={location.pathname.startsWith(Path.Premium)}
    >
      <Star />
    </SideMenuOption>
  );
};

export const PremiumPage = () => {
  const { data: user } = useMyProfile();

  useEffect(() => {
    // Load Stripe pricing table script
    const script = document.createElement("script");
    script.src = "https://js.stripe.com/v3/pricing-table.js";
    script.async = true;
    document.head.appendChild(script);

    return () => {
      // Cleanup script when component unmounts
      const existingScript = document.querySelector('script[src="https://js.stripe.com/v3/pricing-table.js"]');
      if (existingScript) {
        document.head.removeChild(existingScript);
      }
    };
  }, []);

  if (!user) {
    return (
      <CenterOnPage>
        <Card>
          <CircularProgress />
        </Card>
      </CenterOnPage>
    );
  }

  if (!user.emailVerified) {
    return (
      <CenterOnPage>
        <Card style={{ width: "66ch" }}>
          <Box p={2}>
            <Alert severity="error">Please verify your email to upgrade to Premium</Alert>
          </Box>
        </Card>
      </CenterOnPage>
    );
  }

  return (
    <Card>
      <Box>
        <stripe-pricing-table
          pricing-table-id={
            Features.StripeSandbox ? "prctbl_1RreXnEizbybo5tkAzxJbjlh" : "prctbl_1RM5Q6ETLLVGnNG3xENjhusj"
          }
          publishable-key={
            Features.StripeSandbox
              ? "pk_test_51RqjBUEizbybo5tkRSunHVd8Yw9GwZE7UeRZRM64FKk0mSISMAAFwWaXhacmpni0IbR4QG2EKG0CmCGi741VUMyR00dly5roEs"
              : "pk_live_c0Ww7Z6vlVw3Q8sFdRfPmJS4"
          }
          client-reference-id={user.id}
          customer-email={user.email}
        />
      </Box>
    </Card>
  );
};
